module.exports = __webpack_public_path__ + "static/img/daindi_gongzong.8770b0c.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/daindi_gongzong.png
// module id = 0su3
// module chunks = 16